module.exports = __webpack_public_path__ + "img/home_bg_01_1.26fc6e70.png";